export const SnackbarType = {
  Error: 'error',
  Success: 'success'
};
